import React from "react";
import "./Setting.css";
import PersonIcon from "@mui/icons-material/Person";
import TableViewIcon from "@mui/icons-material/TableView";

import ViewInArIcon from "@mui/icons-material/ViewInAr";

import NotificationsIcon from "@mui/icons-material/Notifications";

import RuleIcon from "@mui/icons-material/Rule";

import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import DeleteIcon from "@mui/icons-material/Delete";
import LockIcon from "@mui/icons-material/Lock";
import ToggleOnIcon from "@mui/icons-material/ToggleOn";
import AddShoppingCartIcon from "@mui/icons-material/AddShoppingCart";

import AccountCircleIcon from "@mui/icons-material/AccountCircle";

import CodeIcon from "@mui/icons-material/Code";

import SourceIcon from "@mui/icons-material/Source";
import ErrorIcon from "@mui/icons-material/Error";
import KeyIcon from "@mui/icons-material/Key";
import AddAlertIcon from "@mui/icons-material/AddAlert";
import SmsIcon from "@mui/icons-material/Sms";
import MapIcon from "@mui/icons-material/Map";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import PublicIcon from "@mui/icons-material/Public";
import CircleIcon from "@mui/icons-material/Circle";
import PreviewIcon from "@mui/icons-material/Preview";
import NoAccountsIcon from "@mui/icons-material/NoAccounts";
import LanguageIcon from "@mui/icons-material/Language";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import CreateIcon from "@mui/icons-material/Create";
import Breadcrumbs from "@mui/material/Breadcrumbs";

export default function Settings() {
  return (
    <>
      <main class="main-content my-aut lgin_cntnt position-relative w-auto  border-radius-l  ">
        {/* <div className="container-fluid">
          <div className="card-body">
            <div className="row">
              <div
                class="card text-white bg-primary mb-3 ms-6 col-md-3"
                style={{ maxWidth: "18rem" }}
              >
                <div class="card-body">
                  <h5 class="card-title">RoleType Management</h5>
                  <p class="card-text">
                    <PersonIcon sx={{ fontSize: "180px" }} />
                  </p>
                </div>
              </div>
              <div
                class="card text-white bg-secondary mb-3 ms-7 col-md-3"
                style={{ maxWidth: "18rem" }}
              >
                <div class="card-body">
                  <h5 class="card-title">SMS Management</h5>
                  <p class="card-text">
                    <SourceIcon sx={{ fontSize: "180px" }} />
                  </p>
                </div>
              </div>
              <div
                class="card text-white bg-success mb-3 ms-7 col-md-3"
                style={{ maxWidth: "18rem" }}
              >
                <div class="card-body">
                  <h5 class="card-title">Code Sand box Management</h5>
                  <p class="card-text">
                    <ViewInArIcon sx={{ fontSize: "180px" }} />
                  </p>
                </div>
              </div>
            </div>
            <div className="row mt-5">
              <div
                class="card text-white bg-danger mb-3 col-md-3 ms-6"
                style={{ maxWidth: "18rem" }}
              >
                <div class="card-body">
                  <h5 class="card-title">Alerts Management</h5>
                  <p class="card-text">
                    <AddAlertIcon sx={{ fontSize: "180px" }} />
                  </p>
                </div>
              </div>
              <div
                class="card text-dark bg-warning mb-3 col-md-3 ms-7"
                style={{ maxWidth: "18rem" }}
              >
                <div class="card-body">
                  <h5 class="card-title">Campaign Management</h5>
                  <p class="card-text">
                    <SmsIcon sx={{ fontSize: "180px" }} />
                  </p>
                </div>
              </div>
              <div
                class="card text-dark bg-info mb-3 col-md-3 ms-7"
                style={{ maxWidth: "18rem" }}
              >
                <div class="card-body">
                  <h5 class="card-title">Info Management</h5>
                  <p class="card-text">
                    <MapIcon sx={{ fontSize: "180px" }} />
                  </p>
                </div>
              </div>
            </div>
            <div className="row mt-5">
              <div
                class="card text-dark bg-light mb-3 col-md-3 ms-6"
                style={{ maxWidth: "18rem" }}
              >
                <div class="card-body">
                  <h5 class="card-title">User Management</h5>
                  <p class="card-text">
                    <NoAccountsIcon sx={{ fontSize: "180px" }} />
                  </p>
                </div>
              </div>
              <div
                class="card text-white bg-dark mb-3 col-md-3 ms-7"
                style={{ maxWidth: "18rem" }}
              >
                <div class="card-body">
                  <h5 class="card-title text-white">Password Management</h5>
                  <p class="card-text">
                    <PreviewIcon sx={{ fontSize: "180px" }} />
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div> */}
        <div class="container mt-5 mb-3">
          <div class="row">
            <div class="col-md-3">
              <div class="card p-3 mb-2" style={{ backgroundColor: "#39CCCC" }}>
                <div class="d-flex justify-content-between">
                  <div class="d-flex flex-row align-items-center">
                    <div class="icon">
                      {" "}
                      <PersonIcon />
                    </div>
                    <div class="ms-2 c-details">
                      <h6 class="mb-0">Role</h6> <span>1 days ago</span>
                    </div>
                  </div>
                  <div class="badge">
                    {" "}
                    <span>Role</span>{" "}
                  </div>
                </div>
                <div class="mt-5">
                  <h3 class="heading">
                    Role
                    <br />
                    Management
                  </h3>
                  <div class="mt-5">
                    <div class="progress">
                      <div
                        class="progress-bar"
                        role="progressbar"
                        style={{ width: "50%" }}
                        aria-valuenow="50"
                        aria-valuemin="0"
                        aria-valuemax="100"
                      ></div>
                    </div>
                    <div class="mt-3">
                      {" "}
                      <span class="text1">
                        32 Applied <span class="text2">of 50 capacity</span>
                      </span>{" "}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-3">
              <div class="card p-3 mb-2" style={{ backgroundColor: "#D81B60" }}>
                <div class="d-flex justify-content-between">
                  <div class="d-flex flex-row align-items-center">
                    <div class="icon">
                      {" "}
                      <SourceIcon />
                    </div>
                    <div class="ms-2 c-details">
                      <h6 class="mb-0">SMS</h6> <span>4 days ago</span>
                    </div>
                  </div>
                  <div class="badge">
                    {" "}
                    <span>Messaging</span>{" "}
                  </div>
                </div>
                <div class="mt-5">
                  <h3 class="heading">
                    SMS
                    <br />
                    Management
                  </h3>
                  <div class="mt-5">
                    <div class="progress">
                      <div
                        class="progress-bar"
                        role="progressbar"
                        style={{ width: "50%" }}
                        aria-valuenow="50"
                        aria-valuemin="0"
                        aria-valuemax="100"
                      ></div>
                    </div>
                    <div class="mt-3">
                      {" "}
                      <span class="text1">
                        42 Applied <span class="text2">of 70 capacity</span>
                      </span>{" "}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-3">
              <div class="card p-3 mb-2" style={{ backgroundColor: "#FF851B" }}>
                <div class="d-flex justify-content-between">
                  <div class="d-flex flex-row align-items-center">
                    <div class="icon">
                      {" "}
                      <ErrorIcon />
                    </div>
                    <div class="ms-2 c-details">
                      <h6 class="mb-0">CodeSandBox</h6> <span>2 days ago</span>
                    </div>
                  </div>
                  <div class="badge">
                    {" "}
                    <span>Code</span>{" "}
                  </div>
                </div>
                <div class="mt-5">
                  <h3 class="heading">
                    Code Sand <br />
                    Management
                  </h3>
                  <div class="mt-5">
                    <div class="progress">
                      <div
                        class="progress-bar"
                        role="progressbar"
                        style={{ width: "50%" }}
                        aria-valuenow="50"
                        aria-valuemin="0"
                        aria-valuemax="100"
                      ></div>
                    </div>
                    <div class="mt-3">
                      {" "}
                      <span class="text1">
                        52 Applied <span class="text2">of 100 capacity</span>
                      </span>{" "}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-3">
              <div class="card p-3 mb-2" style={{ backgroundColor: "#605CA8" }}>
                <div class="d-flex justify-content-between">
                  <div class="d-flex flex-row align-items-center">
                    <div class="icon">
                      {" "}
                      <ErrorIcon />
                    </div>
                    <div class="ms-2 c-details">
                      <h6 class="mb-0">Alert Management</h6>{" "}
                      <span>2 days ago</span>
                    </div>
                  </div>
                  <div class="badge">
                    {" "}
                    <span>Code</span>{" "}
                  </div>
                </div>
                <div class="mt-5">
                  <h3 class="heading">
                    Alert Management
                    <br />
                  </h3>
                  <div class="mt-5">
                    <div class="progress">
                      <div
                        class="progress-bar"
                        role="progressbar"
                        style={{ width: "50%" }}
                        aria-valuenow="50"
                        aria-valuemin="0"
                        aria-valuemax="100"
                      ></div>
                    </div>
                    <div class="mt-3">
                      {" "}
                      <span class="text1">
                        52 Applied <span class="text2">of 100 capacity</span>
                      </span>{" "}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-md-3">
              <div class="card p-3 mb-2" style={{ backgroundColor: "#F39C12" }}>
                <div class="d-flex justify-content-between">
                  <div class="d-flex flex-row align-items-center">
                    <div class="icon">
                      {" "}
                      <SourceIcon />
                    </div>
                    <div class="ms-2 c-details">
                      <h6 class="mb-0">Campaign</h6> <span>4 days ago</span>
                    </div>
                  </div>
                  <div class="badge">
                    {" "}
                    <span>Campaign</span>{" "}
                  </div>
                </div>
                <div class="mt-5">
                  <h3 class="heading">
                    Campaign
                    <br />
                    Management
                  </h3>
                  <div class="mt-5">
                    <div class="progress">
                      <div
                        class="progress-bar"
                        role="progressbar"
                        style={{ width: "50%" }}
                        aria-valuenow="50"
                        aria-valuemin="0"
                        aria-valuemax="100"
                      ></div>
                    </div>
                    <div class="mt-3">
                      {" "}
                      <span class="text1">
                        42 Applied <span class="text2">of 70 capacity</span>
                      </span>{" "}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-3">
              <div class="card p-3 mb-2" style={{ backgroundColor: "#3C8DBC" }}>
                <div class="d-flex justify-content-between">
                  <div class="d-flex flex-row align-items-center">
                    <div class="icon">
                      {" "}
                      <ErrorIcon />
                    </div>
                    <div class="ms-2 c-details">
                      <h6 class="mb-0">Info</h6> <span>2 days ago</span>
                    </div>
                  </div>
                  <div class="badge">
                    {" "}
                    <span>Info</span>{" "}
                  </div>
                </div>
                <div class="mt-5">
                  <h3 class="heading">
                    Info <br />
                    Management
                  </h3>
                  <div class="mt-5">
                    <div class="progress">
                      <div
                        class="progress-bar"
                        role="progressbar"
                        style={{ width: "50%" }}
                        aria-valuenow="50"
                        aria-valuemin="0"
                        aria-valuemax="100"
                      ></div>
                    </div>
                    <div class="mt-3">
                      {" "}
                      <span class="text1">
                        52 Applied <span class="text2">of 100 capacity</span>
                      </span>{" "}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-3">
              <div class="card p-3 mb-2" style={{ backgroundColor: "#00C0EF" }}>
                <div class="d-flex justify-content-between">
                  <div class="d-flex flex-row align-items-center">
                    <div class="icon">
                      {" "}
                      <PersonIcon />
                    </div>
                    <div class="ms-2 c-details">
                      <h6 class="mb-0">User</h6> <span>1 days ago</span>
                    </div>
                  </div>
                  <div class="badge">
                    {" "}
                    <span>User</span>{" "}
                  </div>
                </div>
                <div class="mt-5">
                  <h3 class="heading">
                    User
                    <br />
                    Management
                  </h3>
                  <div class="mt-5">
                    <div class="progress">
                      <div
                        class="progress-bar"
                        role="progressbar"
                        style={{ width: "50%" }}
                        aria-valuenow="50"
                        aria-valuemin="0"
                        aria-valuemax="100"
                      ></div>
                    </div>
                    <div class="mt-3">
                      {" "}
                      <span class="text1">
                        32 Applied <span class="text2">of 50 capacity</span>
                      </span>{" "}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-3">
              <div class="card p-3 mb-2" style={{ backgroundColor: "#594B9F" }}>
                <div class="d-flex justify-content-between">
                  <div class="d-flex flex-row align-items-center">
                    <div class="icon">
                      {" "}
                      <SourceIcon />
                    </div>
                    <div class="ms-2 c-details">
                      <h6 class="mb-0">Password</h6> <span>4 days ago</span>
                    </div>
                  </div>
                  <div class="badge">
                    {" "}
                    <span>Password</span>{" "}
                  </div>
                </div>
                <div class="mt-5">
                  <h3 class="heading">
                    Password
                    <br />
                    Management
                  </h3>
                  <div class="mt-5">
                    <div class="progress">
                      <div
                        class="progress-bar"
                        role="progressbar"
                        style={{ width: "50%" }}
                        aria-valuenow="50"
                        aria-valuemin="0"
                        aria-valuemax="100"
                      ></div>
                    </div>
                    <div class="mt-3">
                      {" "}
                      <span class="text1">
                        42 Applied <span class="text2">of 70 capacity</span>
                      </span>{" "}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-3">
            {/* <div class="col-md-4">
              <div class="card p-3 mb-2">
                <div class="d-flex justify-content-between">
                  <div class="d-flex flex-row align-items-center">
                    <div class="icon">
                      {" "}
                      <ErrorIcon />
                    </div>
                    <div class="ms-2 c-details">
                      <h6 class="mb-0">Reddit</h6> <span>2 days ago</span>
                    </div>
                  </div>
                  <div class="badge">
                    {" "}
                    <span>Design</span>{" "}
                  </div>
                </div>
                <div class="mt-5">
                  <h3 class="heading">
                    Software Architect <br />
                    Java - USA
                  </h3>
                  <div class="mt-5">
                    <div class="progress">
                      <div
                        class="progress-bar"
                        role="progressbar"
                        style={{ width: "50%" }}
                        aria-valuenow="50"
                        aria-valuemin="0"
                        aria-valuemax="100"
                      ></div>
                    </div>
                    <div class="mt-3">
                      {" "}
                      <span class="text1">
                        52 Applied <span class="text2">of 100 capacity</span>
                      </span>{" "}
                    </div>
                  </div>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </main>
    </>
  );
}
